import { render, staticRenderFns } from "./RFQOrder.vue?vue&type=template&id=b07a3e3c"
import script from "./RFQOrder.vue?vue&type=script&lang=js"
export * from "./RFQOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports